import { keepPreviousData, useQuery } from "@tanstack/react-query";
import Qs from "qs";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const POLL_INTERVAL_MS = 6e4;
export const fetchInputMetrics = (inputIds, fields) => {
  const query = Qs.stringify({ input_ids: inputIds, fields }, { indices: false });
  return fetch("GET", qualifyUrl(`/system/inputs/metrics?${query}`));
};
const sortedUnique = (values) => Array.from(new Set(values)).sort();
const useInputMetrics = (inputIds, fields) => {
  var _a;
  const stableIds = sortedUnique(inputIds);
  const stableFields = sortedUnique(fields);
  const enabled = stableIds.length > 0 && stableFields.length > 0;
  const { data, isInitialLoading, isError } = useQuery({
    queryKey: ["inputs", "metrics", stableIds, stableFields],
    queryFn: () => defaultOnError(
      fetchInputMetrics(stableIds, stableFields),
      "Loading input metrics failed with status",
      "Could not load input metrics"
    ),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: POLL_INTERVAL_MS
  });
  return {
    metricsByInputId: (_a = data == null ? void 0 : data.metrics) != null ? _a : {},
    isInitialLoading,
    isError
  };
};
export default useInputMetrics;
